import { isCurrentUserEventInitiator } from "@/entities/event/eventDerivedStatuses"
import type { EventDto } from "@/entities/event/types"
import { AUDIT_EVENTS_EXPORT } from "@/features/admin/auditPermissions"
import { isCurrentUserOnEventStaffList } from "@/features/events/eventRegistrationModerationPermissions"

const EVENTS_APPROVE = "LeninkaArt.Events.Approve"

export { EVENTS_APPROVE, AUDIT_EVENTS_EXPORT }

const isGranted = (policies: Record<string, boolean> | null, key: string) =>
  Boolean(policies?.[key])

export const canViewAdminEventRegistry = (
  grantedPolicies: Record<string, boolean> | null,
  isAdmin = false,
) => isGranted(grantedPolicies, EVENTS_APPROVE) || isAdmin

export const canExportEventData = (
  grantedPolicies: Record<string, boolean> | null,
  isAdmin = false,
) => isGranted(grantedPolicies, AUDIT_EVENTS_EXPORT) || isAdmin

/** Портал: глобальный Audit.Events.Export или создатель/любой staff (как EnsureCanExportEventAsync на бэке). */
export const canExportEventInPortal = (
  event: Pick<EventDto, "creatorId" | "staff">,
  userId: string | null | undefined,
  grantedPolicies: Record<string, boolean> | null,
  isAdmin = false,
) =>
  canExportEventData(grantedPolicies, isAdmin) ||
  isCurrentUserEventInitiator(event, userId) ||
  isCurrentUserOnEventStaffList(event, userId)
